<template>
  <div class="container">
    <img class="view-img" :src="gifUrl | imgUrl" :data-id="id" alt="">
    
    <span class="make-success">制作成功</span>

    <span class="to-dou">马上发表情斗图吧</span>

    <div class="btn show-flex-c btn-share" @click="toShare">分享表情</div>
    <div class="btn show-flex-c" @click="back">重做一个</div>
    <!-- <div class="btn show-flex-c" @click="preview">预览</div> -->
    <transition name="zoom-fade">
      <div class="share-layer pos-abs" v-if="showShare" @click="shareTap">
        <div class="bg pos-abs"></div>
        <img class="big-img pos-abs" :src="gifUrl | imgUrl" alt="">
        <div class="info-wrap pos-abs" v-if="showShareTip" @click.stop="shareTip">
          <div class="info">
            <span>轻触屏幕然后长按图片</span>
            <span>发送给朋友</span>
            <div class="circle animated infinite scaleOut"></div>
            <!-- <div class="finger"></div>  -->
            <img class="finger" src="../../static/img/finger.png" alt="">
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
// import CanvasToImg from "../components/CanvasToImg";

let img64Url ='';
let content = '';

export default {
  name: 'ExpressionMain',
  data () {
    return {
      gifUrl:'',
      id:0,
      showShare:false,//显示分享大图
      showShareTip:true,//分享提示层
    }
  },
  created () {
    // this.getData();
  },
  mounted(){
    this.init();
  },
  methods:{
    init(){
      let { gifUrl,id } = this.$route.query;
      this.gifUrl = gifUrl;
      this.id = id;
    },
    toShare(){
      this.showShare = true;
    },
    back(){
      this.$router.go(-1);
    },
    shareTip(){
      console.log((222))
      // this.showShareTip = false;
      this.preview();
    },
    shareTap(){
      console.log(11)
      // if(this.showShareTip){
      //   return;
      // }
      this.showShare = false;
    },
    preview(){
      this.showShare = false;
      let src = this.gifUrl;
      if(src.indexOf('https') == -1){
        src = 'https://running.osports.cn/biqu'+src;
      }
      wx.previewImage({
        urls: [src], // 当前显示图片的http链接
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container{
  text-align: center;
  background: #fafafa;
  width: 100%;
  height: 100%;
  padding-top: 1.40625rem;
}
span{
  display: block;
}
.view-img{
  width: 5.3125rem;
  height: auto;
  display: block;
  margin: 0 auto .625rem;
}
.make-success{
  font-size: .75rem;
  color: #000;
}
.to-dou{
  color: #adadad;
  font-size: .375rem;
  margin: .3125rem auto .78125rem;
}
.btn{
  width: 5.46875rem;
  height: 1.15625rem;
  color: #262626;
  background: #fff;
  margin: 0 auto .390625rem;
  border-radius: .578125rem;
  border: .015625rem solid #cacaca;
}
.btn-share{
  color: #fff;
  background: #23d0a5;
  border: 0;
}
.pos-abs{
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}
.share-layer > .bg{
  background: #000;
  /* z-index: -1; */
}
.share-layer>.big-img{
  left: 50%;
  top: 50%;
  width: 7.96875rem;
  height: 7.96875rem;
  margin-left: -4.140625rem;
  margin-top: -4.140625rem;
}
.info-wrap{
  background: rgba(0, 0, 0, .5);
      z-index: 1000;
}
.info{
  position: absolute;
  width: 100%;
  height: 7.1875rem;
  left: 50%;
  top: 50%;
  margin-top: -3.59375rem;
  margin-left: -5rem;
}
.info > span{
  color: #fff;
  text-align: center;
}
.info > span:nth-child(1){
  font-size: .46875rem;
  margin-bottom: .234375rem;
}
.circle{
  position: absolute;
  width: .625rem;
  height: .625rem;
  bottom: 3.2rem;
  background: #f9cd6a;
  border-radius: 50%;
  overflow: hidden;
  left: 50%;
}
.finger{
  display: block;
  width: 1.6875rem;
  position: absolute;
  left: 50%;
  margin-left: -.84375rem;
  bottom: 0;
  pointer-events: none;
}
@-webkit-keyframes scaleOut {
  0% {
    opacity: 1;
  }
  /* 25% {
    opacity: .75;
    -webkit-transform: scale3d(1.5, 1.5, 1.5);
    transform: scale3d(1.5, 1.5, 1.5);
  }
  50% {
    opacity: .5;
    -webkit-transform: scale3d(2, 2, 2);
    transform: scale3d(2, 2, 2);
  }
  75% {
    opacity: .25;
    -webkit-transform: scale3d(2.5, 2.5, 2.5);
    transform: scale3d(2.5, 2.5, 2.5);
  } */
 
  100% {
    opacity: 0;
    -webkit-transform: scale3d(3, 3, 3);
    transform: scale3d(3, 3, 3);
  }
}
 
@keyframes scaleOut {
  0% {
    opacity: 1;
  }
  /* 25% {
    opacity: .75;
    -webkit-transform: scale3d(1.5, 1.5, 1.5);
    transform: scale3d(1.5, 1.5, 1.5);
  }
  50% {
    opacity: .5;
    -webkit-transform: scale3d(2, 2, 2);
    transform: scale3d(2, 2, 2);
  }
  75% {
    opacity: .25;
    -webkit-transform: scale3d(2.5, 2.5, 2.5);
    transform: scale3d(2.5, 2.5, 2.5);
  } */
 
  100% {
    opacity: 0;
    -webkit-transform: scale3d(3, 3, 3);
    transform: scale3d(3, 3, 3);
  }
}
 
.scaleOut {
  -webkit-animation-name: scaleOut;
  animation-name: scaleOut;
}

</style>



// WEBPACK FOOTER //
// src/pages/ExpressionView.vue